import { ComponentKey } from 'enums/componentKey';
import { InputRenderersFor } from 'factories/input-factory/types';
import { FormikDocumentUploader } from 'features/subscription-process/contractualization-process/components/FormikDocumentUploader';
import { BankAccountSelector } from 'features/subscription-process/contractualization-process/components/mandate/BankAccountSelector';

/* The renderers the contractualization feature CONTRIBUTES to the factory
   registry (assembled at the composition root, src/index.tsx): the core never
   imports them. */
export const contractualizationRenderers: InputRenderersFor<
  ComponentKey.DocumentUploader | ComponentKey.BankAccountSelector
> = {
  [ComponentKey.DocumentUploader]: (cfg, base) => (
    <FormikDocumentUploader
      {...base}
      label={base.label ?? cfg.label}
      successMessage={cfg.successMessage}
      sectionLabel={cfg.sectionLabel}
      accept={cfg.accept}
      fileType={cfg.fileType}
      customDownloadFileName={cfg.customDownloadFileName}
    />
  ),

  [ComponentKey.BankAccountSelector]: () => <BankAccountSelector />,
};
